export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14774.580139e9.jpg";